import {useLocation, useNavigate, NavigateOptions} from 'react-router-dom';

const useBackgroundLocation = () => {
  const location = useLocation();
  const backgroundLocation = location.state?.backgroundLocation || location;
  const navigate = useNavigate();

  const navigateWithBackgroundLocation = (
    url: string,
    options?: NavigateOptions,
  ) => {
    const mergedOptions = {
      ...options,
      state: {backgroundLocation, ...options?.state},
    };

    navigate(url, mergedOptions);
  };

  return {backgroundLocation, navigateWithBackgroundLocation};
};

export default useBackgroundLocation;
